import {
	ReactElement,
	useMemo,
	useState
} from "react";
import { HubItemComposerDialog } from "./HubItemComposerDialog";
import { generateTrackingId } from "client/Misc/utils";

export type InfoAlertOptions = {
	uniqueKey: string;
	message: string;
	shouldShow?: boolean;
};

export function useInfoAlerts(alerts: readonly InfoAlertOptions[]): ReactElement {
	const [dismissedAlerts, setDismissedAlerts] = useState<ReadonlySet<string>>(new Set());

	const alertsToRender = useMemo(
		() => {
			return alerts.filter(a => a.shouldShow !== false
				&& !dismissedAlerts.has(a.uniqueKey)
			);
		},
		[alerts, dismissedAlerts]
	);

	const dismissHandler = (alert: InfoAlertOptions): void => {
		setDismissedAlerts((x: ReadonlySet<string>): ReadonlySet<string> => {
			const copy = new Set<string>(x);

			copy.add(alert.uniqueKey);

			return copy;
		});
	};

	return useMemo(
		(): ReactElement => {
			return (
				<>
					{alertsToRender.map(a => (
						<HubItemComposerDialog.AlertBar
							key={a.uniqueKey}
							text={a.message}
							trackingId={generateTrackingId("info-alert", `|${a.uniqueKey}`)}
							onDismiss={() => dismissHandler(a)}
						/>
					))}
				</>
			);
		},
		[alertsToRender]
	);
}